import { SortBuilder as UiSortBuilder } from "@tfg/ui"
import type {
  SortBuilderLabels,
  SortBuilderProps as UiSortBuilderProps,
  SortDirection,
  SortValue,
  Sorts,
} from "@tfg/ui"
import { useTranslation } from "react-i18next"

export type SortBuilderProps<T> = Omit<UiSortBuilderProps<T>, "labels"> & {
  readonly labels?: SortBuilderLabels
}

export const SortBuilder = <T extends Record<string, SortValue>>({
  labels,
  ...props
}: SortBuilderProps<T>) => {
  const { t } = useTranslation("common")

  const translatedLabels: SortBuilderLabels = {
    title: t("sort.title"),
    searchPlaceholder: t("sort.search.placeholder"),
    ascending: t("sort.ascending"),
    descending: t("sort.descending"),
  }

  return <UiSortBuilder {...props} labels={labels ?? translatedLabels} />
}

export type { SortBuilderLabels, SortDirection, SortValue, Sorts }
